import { render, staticRenderFns } from "./ResultL.vue?vue&type=template&id=4544a1ae&"
import script from "./ResultL.vue?vue&type=script&lang=js&"
export * from "./ResultL.vue?vue&type=script&lang=js&"
import style0 from "./ResultL.vue?vue&type=style&index=0&id=4544a1ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports